import styled from "styled-components"
import { breakpointSmall } from "../../variables"

export const HeadingOne = styled.h1`
  font-size: ${({ fontSize }) => fontSize && fontSize};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "initial")};
  margin: ${({ margin }) => (margin ? margin : "initial")};
  padding: ${({ padding }) => (padding ? padding : "initial")};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  text-transform: ${({ textTransform }) =>
    textTransform ? textTransform : "initial"};
  color: ${({ color }) => color && color};
  text-align: ${({ textAlign }) => textAlign && textAlign};
  letter-spacing: ${({ letterSpacing }) => letterSpacing && letterSpacing};

  @media (min-width: ${breakpointSmall}) {
    font-size: ${({ fontSizeMd, fontSize }) =>
      fontSizeMd ? fontSizeMd : fontSize};
    line-height: ${({ lineHeightMd, lineHeight }) =>
      lineHeightMd ? lineHeightMd : lineHeight};
    margin: ${({ marginMd, margin }) => (marginMd ? marginMd : margin)};
    padding: ${({ paddingMd, padding }) => (paddingMd ? paddingMd : padding)};
  }
`

export const HeadingTwo = styled.h2`
  font-size: ${({ fontSize }) => fontSize && fontSize};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "initial")};
  margin: ${({ margin }) => (margin ? margin : "initial")};
  padding: ${({ padding }) => (padding ? padding : "initial")};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  text-transform: ${({ textTransform }) =>
    textTransform ? textTransform : "initial"};
  color: ${({ color }) => color && color};
  text-align: ${({ textAlign }) => textAlign && textAlign};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing ? letterSpacing : "0.07em"};

  @media (min-width: ${breakpointSmall}) {
    font-size: ${({ fontSizeMd, fontSize }) =>
      fontSizeMd ? fontSizeMd : fontSize};
    line-height: ${({ lineHeightMd, lineHeight }) =>
      lineHeightMd ? lineHeightMd : lineHeight};
    margin: ${({ marginMd, margin }) => (marginMd ? marginMd : margin)};
    padding: ${({ paddingMd, padding }) => (paddingMd ? paddingMd : padding)};
  }
`

export const HeadingThree = styled.h3`
  font-size: ${({ fontSize }) => fontSize && fontSize};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "initial")};
  margin: ${({ margin }) => (margin ? margin : "initial")};
  padding: ${({ padding }) => (padding ? padding : "initial")};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  text-transform: ${({ textTransform }) =>
    textTransform ? textTransform : "initial"};
  color: ${({ color }) => color && color};
  text-align: ${({ textAlign }) => textAlign && textAlign};
  letter-spacing: ${({ letterSpacing }) => letterSpacing && letterSpacing};
  font-family: ${({ fontFamily }) => fontFamily && fontFamily};

  @media (min-width: ${breakpointSmall}) {
    font-size: ${({ fontSizeMd, fontSize }) =>
      fontSizeMd ? fontSizeMd : fontSize};
    line-height: ${({ lineHeightMd, lineHeight }) =>
      lineHeightMd ? lineHeightMd : lineHeight};
    margin: ${({ marginMd, margin }) => (marginMd ? marginMd : margin)};
    padding: ${({ paddingMd, padding }) => (paddingMd ? paddingMd : padding)};
  }
`

export const SectionHeading = styled(HeadingThree)`
  letter-spacing: 0.1em;
  text-transform: uppercase;
`

export const Paragraph = styled.p`
  font-size: ${({ fontSize }) => fontSize && fontSize};
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "initial")};
  margin: ${({ margin }) => (margin ? margin : "initial")};
  padding: ${({ padding }) => (padding ? padding : "initial")};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  text-transform: ${({ textTransform }) =>
    textTransform ? textTransform : "initial"};
  color: ${({ color }) => color && color};
  text-align: ${({ textAlign }) => textAlign && textAlign};

  @media (min-width: ${breakpointSmall}) {
    font-size: ${({ fontSizeMd, fontSize }) =>
      fontSizeMd ? fontSizeMd : fontSize};
    line-height: ${({ lineHeightMd, lineHeight }) =>
      lineHeightMd ? lineHeightMd : lineHeight};
    margin: ${({ marginMd, margin }) => (marginMd ? marginMd : margin)};
    padding: ${({ paddingMd, padding }) => (paddingMd ? paddingMd : padding)};
  }
`
